import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Founder from './components/Founder';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Terms from './components/Terms';
import './styles/App.css';

// Paths that should render the Terms & Conditions page.
const TERMS_PATHS = ['/t&c', '/terms', '/terms-and-conditions'];

function App() {
  const path = decodeURIComponent(window.location.pathname).replace(/\/+$/, '').toLowerCase() || '/';

  if (TERMS_PATHS.includes(path)) {
    return (
      <div className="App">
        <Terms />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <About />
      <Founder />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;